import { Toaster } from 'sonner';
import { AppRouter } from '@/router';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { useThemeStore } from '@/stores/theme';

export default function App() {
  const resolved = useThemeStore((s) => s.resolved);
  return (
    <ErrorBoundary>
      <AppRouter />
      <Toaster
        position="top-right"
        richColors
        closeButton
        theme={resolved}
      />
    </ErrorBoundary>
  );
}
